import { post, get, downloadFile, patch, deleteRequest } from 'utils/api';

export const sendSAPInvoiceB2CRecordsCGSTSGST = (data) => {
  const page = data.page ? data.page : 1; // Extract the page parameter
  const queryData = { ...data }; // Create a copy of the data object
  delete queryData.page; // Remove the page parameter from the payload

  // Append the page parameter to the query string
  return post(`/sapRoute/send-b2c-data-to-sap-cgst-sgst?page=${parseInt(page)}`, queryData);
};
export const sendSAPInvoiceB2CRecordsIGST = (data) => {
  return post('/sapRoute/send-b2c-data-to-sap-igst', data)
}

export const getSapMonthlyData = (data) => {
  return get('/sapRoute/get-sap-data', data)
}
export const generateExcel = (data) => {
  return downloadFile('/sapRoute/invoice-records-b2c', data)
}

export const b2cPagination = (data) => {
  return post('/sapRoute/b2c-pagination-info', data)
}

export const sapFaultyBookingReport = (data) => {
  const page = data.page ? data.page : 1;
  if (data.sortBy && page && data.search) {
    const sortBy = data.sortBy;
    const search = data.search;
    delete data['page'];
    delete data['sortBy'];
    delete data['search'];
    return post(`/charger_bookings/sapFaultyBookings?page=${parseInt(page)}&sortBy=${sortBy}&search=${search}`, data);
  } else if (page && data.search) {
    const search = data.search;
    delete data['page'];
    delete data['search'];
    return post(`/charger_bookings/sapFaultyBookings?page=${parseInt(page)}&search=${search}`, data);
  } else if (data.sortBy && data.search) {
    const sortBy = data.sortBy;
    const search = data.search;
    delete data['search'];
    delete data['sortBy'];
    return post(`/charger_bookings/sapFaultyBookings?search=${search}&sortBy=${sortBy}`, data);
  } else if (data.sortBy && page) {
    const sortBy = data.sortBy;
    delete data['page'];
    delete data['sortBy'];
    return post(`/charger_bookings/sapFaultyBookings?page=${parseInt(page)}&sortBy=${sortBy}`, data);
  } else if (data.search) {
    const search = data.search;
    delete data['search'];
    return post(`/charger_bookings/sapFaultyBookings?search=${search}`, data);
  } else if (data.sortBy) {
    const sortBy = data.sortBy;
    delete data['sortBy'];
    return post(`/charger_bookings/sapFaultyBookings?sortBy=${sortBy}`, data);
  } else {
    delete data['page'];
    return post(`/charger_bookings/sapFaultyBookings?page=${parseInt(page)}`, data);
  }
};



export const getSapOcpiPartnerList = (data) => {
  return get('/sapOcpiPartner/list', data)
}

export const fetchSapOcpiCredList = (data) => {
  return get('/sapOcpiPartner/ocpi-credentials', data)
}

export const addSapOcpiCredList = (data) => {
  return post('/sapOcpiPartner/create-Sap-Ocpi-Partner', data)
}

export const updateSapOcpiCredList = (data) => {
  const id = data.id
  return patch(`/sapOcpiPartner/update/${id}`, data)
}

export const deleteSapOcpiCredList = (id) => {
  return deleteRequest(`/sapOcpiPartner/delete/${id}`)
}

export const generateSapInvoicesWithGst = (data) => {
  return post('/sapOcpiPartner/generate-statewise-invoices', data)
}


export const fetchSapInvoicesWithGst = (data) => {
  return post('/sapOcpiPartner/generate-invoices-with-gst', data)
}

export const downloadSapInvoicesWithGst = (data) => {
  return downloadFile('/sapOcpiPartner/generate-invoices-with-gst', data)
}

export const triggerLogitaxOcpiInvoices = (data) => {
  return post('/sapOcpiPartner/trigger-logitax-ocpi-invoices', data)
}


export const querySapMonthlyData = (data) => {
  return post('/sapRoute', data)
}

export const getSignedUrlForExcel = (data) => {
  return post('/sapRoute/download', data)
}

export const deleteSapMonthlyData = (id) => {
  return deleteRequest(`/sapRoute/${id}`)
}

export const fetchSapStationDetails = (data = {}) => {
  const params = new URLSearchParams();

  if (data.search) {
    params.append('search', data.search);
  }

  if (data.page) {
    params.append('page', data.page);
  }

  if (data.limit) {
    params.append('limit', data.limit);
  }

  // Choose endpoint based on is_external_station
  const baseUrl = data.is_external_station === true
    ? '/sapRoute/external-stations'
    : '/sapRoute/stations';

  const queryString = params.toString();
  const url = `${baseUrl}${queryString ? `?${queryString}` : ''}`;

  return get(url);
};

export const updateSapStationDetails = (data) => {
  
  const url = data.is_external_station
    ? '/sapRoute/update-external-stations-sap'
    : '/sapRoute/update-stations-sap';

  return patch(url, data);
};


export const sap = {
  sendSAPInvoiceB2CRecordsCGSTSGST,
  sendSAPInvoiceB2CRecordsIGST,
  getSapMonthlyData,
  sapFaultyBookingReport,
  getSapOcpiPartnerList,
  fetchSapOcpiCredList,
  addSapOcpiCredList,
  updateSapOcpiCredList,
  deleteSapOcpiCredList,
  generateSapInvoicesWithGst,
  downloadSapInvoicesWithGst,
  triggerLogitaxOcpiInvoices,
  fetchSapInvoicesWithGst,
  generateExcel,
  querySapMonthlyData,
  getSignedUrlForExcel,
  deleteSapMonthlyData,
  b2cPagination,
  fetchSapStationDetails,
  updateSapStationDetails
};
